import { TaskInJobDto, ReferredEntityChange } from '@/api/generator';
import { InlineValidationType } from '@/components/forms/InlineValidationError/types';

export function getValidationErrorType(task: TaskInJobDto): InlineValidationType {
  switch (task.taskAreaChange) {
    case ReferredEntityChange.NotAvailable:
      return 'error';
    case ReferredEntityChange.Deleted:
      return 'warning';
    default:
      return 'error';
  }
}
